import { defineMessages } from "@formatjs/intl"
import type { VehicleStatus } from "./VehicleStatus"

export const vehicleStatusMessages = defineMessages<VehicleStatus>({
	AVAILABLE: {
		defaultMessage: "Available",
		id: "salesStatus.available",
	},
	DELIVERED: {
		defaultMessage: "Delivered",
		id: "salesStatus.delivered",
	},
	ONLINE_ORDERED: {
		defaultMessage: "Online ordered",
		id: "salesStatus.onlineOrdered",
	},
	ONLINE_RESERVED: {
		defaultMessage: "Online reserved",
		id: "salesStatus.onlineReserved",
	},
	OPEN_CAMPAIGNS: {
		defaultMessage: "Open campaigns",
		id: "salesStatus.openCampaigns",
	},
	REMOVED: {
		defaultMessage: "Removed",
		id: "stockStatus.removed",
	},
	RESERVED: {
		defaultMessage: "Reserved",
		id: "salesStatus.reserved",
	},
	SOLD: {
		defaultMessage: "Sold",
		id: "salesStatus.sold",
	},
	SOLD_LINK: {
		defaultMessage: "Sold",
		id: "salesStatus.soldLink",
	},
})
